import React, { useState, useEffect, useRef } from "react";
import "../css/whatsappchat.css";
import api from '../api/axios';

const WhatsAppChat = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const buttonRef = useRef(null);
  const defaultAdvisors = [
    { name: 'Pcvasquez', role: 'Principal', phoneNumber: '573005934724' },
    { name: 'Esteban', role: 'Asesor', phoneNumber: '573127315906' },
    { name: 'Ana Karina', role: 'Asesor', phoneNumber: '573137287519' }
  ];
  const [advisors, setAdvisors] = useState(defaultAdvisors);

  useEffect(() => {
    api.get('/settings').then(({ data }) => {
      if (data.settings?.advisors?.length) setAdvisors(data.settings.advisors);
    }).catch(() => {});
  }, []);

  // Muestra el selector de asesores sin abrir WhatsApp ni iniciar un chat.
  // Se ejecuta una vez cada vez que el visitante entra a una página con el componente.
  useEffect(() => {
    const openMenuTimer = window.setTimeout(() => setIsMenuOpen(true), 5000);
    return () => window.clearTimeout(openMenuTimer);
  }, []);

  const handleChat = (phoneNumber) => {
    const defaultMessage = "Hola, me gustaría recibir asesoría."  ;
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(defaultMessage)}`;
    window.open(whatsappURL, "_blank");
    setIsMenuOpen(false); // Cierra el menú después de elegir un asesor
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setIsMenuOpen(false);
      }
    };

    if (isMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMenuOpen]);

  // SVG WhatsApp ícono en color #0b4741
  const WhatsAppIcon = (
    <svg
      width="32"
      height="32"
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
      fill="#0b4741"
    >
      <g>
        <path d="M256 0C114.693 0 0 114.693 0 256c0 56.213 16.893 108.293 45.949 152.32L0 512l103.68-45.92C148.293 510.4 201.707 512 256 512c141.307 0 256-114.693 256-256S397.307 0 256 0zm0 472c-41.066 0-81.253-10.891-117.877-31.496l-7.822-4.721-68.213 17.84 18.32-65.973-4.86-7.699C48.64 334.773 40 296.32 40 256 40 140.8 140.8 40 256 40s216 100.8 216 216-100.8 216-216 216z" />
        <path d="M380.587 308.053c-6.222-3.1-36.746-18.115-42.417-20.192-5.67-2.077-9.81-3.117-13.93 3.117-4.12 6.234-15.9 20.192-19.48 24.34-3.58 4.148-6.624 4.666-12.693 1.554-34.5-17.243-57.15-30.78-79.78-69.78-6.031-10.423 6.031-9.697 17.246-32.244 1.91-4.148.956-7.778-.502-10.875-1.437-3.117-13.04-34.168-17.886-46.844-4.71-11.533-9.533-9.951-13.07-10.17-3.393-.223-7.292-.264-11.173-.264s-10.336 1.437-15.73 7.173c-5.395 5.734-20.684 20.28-20.684 49.53s21.203 57.387 24.147 61.362c2.945 3.976 40.84 62.76 99.103 87.97 13.865 5.98 24.633 9.53 32.998 12.205 13.841 4.41 26.457 3.788 36.424 2.302 11.08-1.656 34.135-13.925 38.96-27.35 4.828-13.425 4.828-24.976 3.414-27.355-1.44-2.332-5.33-3.677-11.118-6.51z" />
      </g>
    </svg>
  );

  return (
    <div className="whatsapp-container">
      {/* Botón de WhatsApp */}
      <div
        className="whatsapp-button"
        ref={buttonRef}
        onClick={() => setIsMenuOpen((prev) => !prev)}
      >
        {isMenuOpen ? "✖" : WhatsAppIcon}
      </div>

      {/* Menú desplegable */}
      {isMenuOpen && (
        <div className="whatsapp-menu" ref={menuRef}>
          {advisors.map((advisor, index) => (
            <div
              key={index}
              className="whatsapp-card"
              onClick={() => handleChat(advisor.phoneNumber)}
            >
              <div className="whatsapp-icon">{WhatsAppIcon}</div>
              <div className="whatsapp-info">
                <p className="whatsapp-name">{advisor.name}</p>
                <p className="whatsapp-role">{advisor.role}</p>
              </div>
              <img
                src="https://cdn-icons-png.flaticon.com/512/733/733585.png"
                alt="Ir al chat"
                className="whatsapp-go-icon"
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default WhatsAppChat;
